import { createI18n } from 'vue-i18n'
import zhCN from '@/locales/zh-CN'
import enUS from '@/locales/en-US'

// 从 localStorage 读取语言设置
function getSavedLocale() {
  return localStorage.getItem('admin_locale')
}

// 检测浏览器语言
function getBrowserLocale() {
  const lang = navigator.language || navigator.userLanguage
  // 如果是中文（包括zh-CN, zh-TW, zh-HK等），返回中文
  if (lang.startsWith('zh')) {
    return 'zh-CN'
  }
  // 其他语言一律使用英文
  return 'en-US'
}

// 获取初始语言
// 注意：登录页面应该使用浏览器默认语言，登录后的页面使用保存的语言
// 这里先使用浏览器默认语言，登录后的页面会在路由守卫中从 localStorage 读取
function getInitialLocale() {
  // 优先从 localStorage 读取（用于登录后的页面）
  const savedLocale = getSavedLocale()
  if (savedLocale === 'zh-CN' || savedLocale === 'en-US') {
    return savedLocale
  }
  // 如果没有保存的语言，使用浏览器默认语言（用于登录页面）
  return getBrowserLocale()
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: getInitialLocale(), // 优先从 localStorage 读取，否则使用浏览器默认语言
  fallbackLocale: 'en-US', // 回退语言
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

// 导出函数供外部使用
export function setLocale(locale) {
  i18n.global.locale.value = locale
}

export function getLocale() {
  return i18n.global.locale.value
}

export default i18n

